// navigationService.ts
import {NavigateFunction} from "react-router-dom";

let navigateRef: NavigateFunction | null = null;

export function setGlobalNavigate(navigate: NavigateFunction) {
    navigateRef = navigate;
}

export function hardNavigate(
    to: string,
    options?: { replace?: boolean }
) {
    if (navigateRef) {
        navigateRef(to, options);
        return;
    }
    console.warn("Global navigate not initialized yet");
    // Router not initialized yet — do a true hard redirect
    // Replace will replace the current history entry, so user can't go back to the previous page
    if (options?.replace) {
        window.location.replace(to);
    } else {
        window.location.href = to;
    }
}
